import { fillVariants } from "../../../styles/utils/fill"
import { classNames } from "../../../utils"
import type { IconProps } from "../../types"

export const Offer = ({
  size = 24,
  fill = "current",
  fillAttribute = "currentColor",
  className,
  ...rest
}: IconProps) => {
  return (
    <svg
      aria-label="Offer"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      role="img"
      viewBox="0 0 16 16"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8.00005 13.6668L1.05005 9.88343L2.45005 9.11676L8.00005 12.1501L13.55 9.11676L14.95 9.88343L8.00005 13.6668Z"
        opacity="0.2"
      />
      <path d="M8.00008 11L0.666748 7L8.00008 3L15.3334 7L8.00008 11Z" />
    </svg>
  )
}
